module.exports = __webpack_public_path__ + "static/media/nft3.4b893a41.jpg";